var map = {
	"./anm-card.png": 572,
	"./arrow.png": 573,
	"./btn-blue-m-v2.png": 574,
	"./btn-blue-m.png": 575,
	"./btn-white-m-v2.png": 576,
	"./btn-white-m.png": 577,
	"./dummy-1.png": 578,
	"./eeziepay.svg": 579,
	"./fcl.svg": 580,
	"./fpx-logo.svg": 581,
	"./game-blue.png": 582,
	"./game-img.png": 583,
	"./game-white.png": 584,
	"./global-language.svg": 585,
	"./ifm-logo.svg": 586,
	"./logo-anniversary.png": 587,
	"./logo-christmas.png": 588,
	"./logo-cny-dragon.png": 589,
	"./logo-cny.png": 590,
	"./logo-halloween.png": 591,
	"./logo-merdeka.png": 592,
	"./logo-mooncake.png": 593,
	"./logo-raya.png": 594,
	"./logo-uefa.png": 595,
	"./merchant-logo.png": 96,
	"./modal-bg.jpg": 596,
	"./number-bg.png": 597,
	"./pagcor.svg": 598,
	"./pool-bg.png": 599,
	"./side-bar-bg.png": 600,
	"./tether.svg": 601,
	"./x33-logo-wc.png": 602,
	"./x33-logo.png": 603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 571;